// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("641792d_bundle." + chunkId + ".js");